import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ConclaveInfo: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.2 }}
      className="mt-8 sm:mt-16 mb-8 sm:mb-12 mx-4 sm:mx-auto bg-gray-800 bg-opacity-70 rounded-lg p-4 sm:p-6 shadow-xl"
    >
      <h2 className="text-2xl md:text-3xl font-bold text-center text-yellow-500 mb-6">
        Qu'est-ce qu'un conclave ?
      </h2>
      
      <p className="text-gray-300 mb-6 text-center max-w-3xl mx-auto">
        Le conclave est l'assemblée des cardinaux électeurs se réunissant dans la chapelle Sixtine pour élire un nouveau pape. 
        Ce processus est l'un des rituels les plus anciens de l'Église catholique.
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mt-6 sm:mt-8">
      <motion.div
          whileHover={{ scale: 1.03 }}
          className="bg-gray-900 rounded-lg overflow-hidden shadow-lg"
        >
          <div className="w-full h-40 overflow-hidden">
            <img 
              src="https://3dvf.com/wp-content/uploads/2024/12/sixtine.jpg" 
              alt="Chapelle Sixtine" 
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
            />
          </div>
          <div className="p-4 sm:p-5">
            <Link to="/electing-pope">
              <h3 className="text-xl font-semibold text-yellow-500 mb-3 hover:text-yellow-400 transition-colors cursor-pointer">Tout savoir sur l'élection du Pape</h3>
            </Link>
            <p className="text-gray-400 mb-4">
              Découvrez les détails du processus du conclave, les rituels, le vote et l'annonce tant attendue : "Habemus Papam".
            </p>
            <Link 
              to="/electing-pope" 
              className="inline-block mt-2 text-yellow-500 hover:text-yellow-400 transition-colors"
            >
              En savoir plus →
            </Link>
          </div>
        </motion.div>
        <motion.div
          whileHover={{ scale: 1.03 }}
          className="bg-gray-900 rounded-lg overflow-hidden shadow-lg"
        >
          <div className="w-full h-40 overflow-hidden">
            <img 
              src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhQpmU6jd9_jZ0pgzLNv7wIlr3hr96ChP7Sa5nhyphenhyphenXgMSK1_EKcHbnKTNVwjo9U-UobwgbI9sFGJ-MMe1KYv4gMZJFLexFc0kexvE5ZBRsSqVhn4yT9O_o7YPyN8s1G2ppZ3FbYOYQuN6u8/s1600/d2.jpg"
              alt="Collège des Cardinaux" 
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
            />
          </div>
          <div className="p-4 sm:p-5">
            <Link to="/history-cardinalate">
              <h3 className="text-xl font-semibold text-yellow-500 mb-3 hover:text-yellow-400 transition-colors cursor-pointer">Petite histoire du Collège des Cardinaux</h3>
            </Link>
            <p className="text-gray-400 mb-4">
              Au fait, c'est quoi le collège des cardinaux ? Découvrez l'évolution du collège des cardinaux et de ses fonctions à travers les siècles.
            </p>
            <Link 
              to="/history-cardinalate" 
              className="inline-block mt-2 text-yellow-500 hover:text-yellow-400 transition-colors"
            >
              En savoir plus →
            </Link>
          </div>
        </motion.div>
        
        <motion.div
          whileHover={{ scale: 1.03 }}
          className="bg-gray-900 rounded-lg overflow-hidden shadow-lg"
        >
          <div className="w-full h-40 overflow-hidden">
            <img 
              src="https://tribunechretienne.com/wp-content/uploads/2024/01/cOLLEGE.jpg" 
              alt="Rôles des Cardinaux" 
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
            />
          </div>
          <div className="p-4 sm:p-5">
            <Link to="/cardinal-roles">
              <h3 className="text-xl font-semibold text-yellow-500 mb-3 hover:text-yellow-400 transition-colors cursor-pointer">Rôles des Cardinaux</h3>
            </Link>
            <p className="text-gray-400 mb-4">
            Ça sert à quoi un cardinal ? Découvrez les différents rôles et fonctions des cardinaux dans l'Église, leur influence dans la gouvernance ecclésiale et leur rôle de conseillers du Saint-Père.
            </p>
            <Link 
              to="/cardinal-roles" 
              className="inline-block mt-2 text-yellow-500 hover:text-yellow-400 transition-colors"
            >
              En savoir plus →
            </Link>
          </div>
        </motion.div>
        

      </div>
    </motion.div>
  );
};

export default ConclaveInfo;
